<div class="notification-message-container m-0  m-b-20 flex flex-row justify-between items-center">
  <div>
    <span>Note:</span> <span>Once you are ready to submit your response for this Data Survey, please provide the details below and click 'Done'. The status gives the reviewer a quick reference on the status of your response, e.g. if you consider this data survey to be complete.</span>
  </div>
</div>
<form [formGroup]="inputForm" class="flex flex-col">
  <div class="flex flex-row justify-start items-start auto-flex">
    <mat-form-field appearance="outline" class="flex-0-0-100">
      <mat-label>Status</mat-label>
      <mat-select formControlName="status">
        <mat-option value="Draft">
          Draft
        </mat-option>
        <mat-option value="Completed">
          Completed
        </mat-option>
        <mat-option value="Cancelled">
          Cancelled
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="flex flex-row justify-start items-start auto-flex">
    <mat-form-field appearance="outline" class="flex-0-0-100">
      <mat-label>Description</mat-label>
      <textarea formControlName="description" matInput placeholder="Description" rows="5"></textarea>
    </mat-form-field>
  </div>
</form>
